import { render, staticRenderFns } from "./EventReview.vue?vue&type=template&id=593e8dc0&"
import script from "./EventReview.vue?vue&type=script&lang=js&"
export * from "./EventReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports